import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames/bind'

import BaseButton from '../base/base_button'

import styles from './animated_toolbar_button.scss'

const cx = classNames.bind(styles)

const AnimatedToolbarButton = props => (
	<div className={cx({ disabled: props.bgColor === 'border-green'})}>
		<BaseButton
			{...props}
			bgColor={props.bgColor}
			fontColor='white' />
	</div>
)

AnimatedToolbarButton.propTypes = {
	bgColor: PropTypes.string,
}

AnimatedToolbarButton.defaultProps = {
	bgColor: 'border-green',
}

export default AnimatedToolbarButton
